.clearButton {
    background-color: rgba(0, 0, 0, 0.6);
    color: var(--mantine-color-white);
    border: 1px solid rgba(255, 255, 255, 0.25);
    backdrop-filter: blur(2px);
    transition:
        background-color 120ms ease,
        border-color 120ms ease;

    &:hover {
        background-color: rgba(0, 0, 0, 0.85);
        border-color: rgba(255, 255, 255, 0.5);
    }
}
